module.exports = __webpack_public_path__ + "static/media/teygja_framanverdlaeri_small.db3120d9.png";